import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import queryString from 'qs';
import { Button, Modal, Tooltip } from 'antd';
import axios from 'axios';
import SearchBar from '../SearchBar';
import Settings from '../Settings';
import PlotterContainer from '../Plotter';
import './App.css';

/*
 * Get a list of nearby stations to pre-populate the plotter
 */
function get_nearby_stations( station, num_of_nearby_stations, callback, type_of_nearby_stations = 'gps') {
    const url = 'http://web-services.unavco.org/internalWS/nearbystations/' + station + '/beta?n=' + num_of_nearby_stations + '&type=' + type_of_nearby_stations;
    let nearby_fourcharid = [];

    axios.get(  url )
        .then( function( response ){

            for( let i = 0; i < response.data.length; i++ ) {
                nearby_fourcharid.push( response.data[ i ].fourcharid );
            }

            callback( nearby_fourcharid );
        } )
        .catch( ( error ) => {
            console.log('Error fetching nearby stations' );
            console.log( error );
        })
}

/*
 * Main application component for plotting tool
 */
class App extends Component{
    constructor( props ){
        super( props );

        this.state = {
            stations : [],
            reference_frame : this.props.default_reference_frame,
            processing : this.props.default_processing,
            annotations : [],
            view : this.props.default_view,
            settings_visible : false,
            help_visible : false
        };

        this.handleChange = this.handleChange.bind( this );
        this.handleViewSwitch = this.handleViewSwitch.bind( this );
    }

    /*
     * Handle application changes from child components and update URL accordingly
     */
    handleChange( key, value ){
        this.setState({
            [ key ] : value
        });

        let query_object = queryString.parse( this.props.location.search.substring( 1 ) );

        // Delete query parameters related to nearby stations if user starts to add/delete stations for customization
        if( key === 'stations' ) {
            delete query_object.nearby;
            delete query_object.n;
        }

        if( ( Array.isArray( value ) === true ) && ( value.length > 0 ) ){
            query_object[ key ] = value.toString();
        } else {
            query_object[ key ] = value;
        }

        // Pushes querystring object to URL as a reflection of application state
        this.props.history.push({
            pathname : query_object.pathname,
            search : queryString.stringify( query_object )
        });
    }

    handleViewSwitch( viewmode, e ){
        e.stopPropagation();

        this.handleChange( 'view', viewmode );
    }

    /*
     * Updates the application from the URL parameters if there is a query/search string
     */
    update_state_from_URL = ( data = this.props.location.search.substring( 1 ) ) =>{
        if( data.length > 0 ) {
            const query = queryString.parse(data);

            if( query.nearby ){
                get_nearby_stations( query.nearby , query.n ? query.n : '10', stations => {
                    this.setState({
                        stations : stations,
                        reference_frame : query.reference_frame ? query.reference_frame : this.props.default_reference_frame,
                        processing : query.processing ? query.processing : this.props.default_processing,
                        annotations : query.annotations ? query.annotations.split(',') : [],
                        view : query.view ? query.view : this.props.default_view
                    });
                });
            } else {
                this.setState({
                    stations : query.stations ? query.stations.split(',') : [],
                    reference_frame : query.reference_frame ? query.reference_frame : this.props.default_reference_frame,
                    processing : query.processing ? query.processing : this.props.default_processing,
                    annotations : query.annotations ? query.annotations.split(',') : [],
                    view : query.view ? query.view : this.props.default_view
                });
            }
        }
    }

    displaySettings( visibility ){
        this.setState({
            settings_visible : visibility
        });
    }

    displayHelp( visibility ){
        this.setState({
            help_visible : visibility
        });
    }

    /*
     * On initial load, update app from URL state
     */
    componentDidMount() {
        this.update_state_from_URL();
    }

    /*
     * This function is called on component update ie state changes; The only time when the next and current state
     * remains the same and the location property is different is during back/forward button presses.
     * If that is the case, we prevent the component from updating automatically and call for an update base upon the
     * URL.
     */
    shouldComponentUpdate( nextProps, nextState ){
        if( ( this.state === nextState ) && ( this.props.location.search !== nextProps.location.search ) ){
            // Handles logic for when back/forward buttons are pressed
            this.update_state_from_URL( nextProps.location.search );
            return false;
        } else {
            return true;
        }
    }

    /*
     * Renders
     */
    render() {
        return (
            <div className="App">
                <div className="sticky-wrapper">
                    <div className="nav-secondary flex">
                        <nav className="menu-horizontal">
                            <span>View Mode:</span>
                            <ul>
                                <li className = { this.state.view === 'multi' ? 'active' : '' }>
                                    <Tooltip title = "Show all time series on one graph">
                                        <a href={ null } onClick={ (e) => this.handleViewSwitch( 'multi', e ) }>Consolidated</a>
                                    </Tooltip>
                                </li>
                                <li className = { this.state.view === 'single' ? 'active' : '' }>
                                    <Tooltip title = "Show time series as individual graphs">
                                        <a href={ null } onClick={ (e) => this.handleViewSwitch( 'single', e ) }>Individual Graphs</a>
                                    </Tooltip>
                                </li>
                            </ul>
                        </nav>
                        <Button.Group>
                            <Tooltip title="Settings">
                                <Button type="default" shape="circle" icon="setting" onClick={ (e) => this.displaySettings( true, e ) }/>
                            </Tooltip>
                            <Tooltip title="Help">
                                <Button type="primary" shape="circle" icon="question-circle" onClick={ (e) => this.displayHelp( true, e )}/>
                            </Tooltip>
                        </Button.Group>
                    </div>

                    <div className="nav-secondary">
                        <SearchBar params = { this.state } onChange =  { this.handleChange } />
                    </div>
                </div>

                <div className="content">
                    <PlotterContainer params = { this.state }/>
                </div>

                <Modal
                    title = 'Settings'
                    width = '70%'
                    centered
                    visible = { this.state.settings_visible }
                    footer = { null }
                    onCancel = { () => this.displaySettings( false ) }
                >
                    <Settings params = { this.state } onChange =  { this.handleChange } />
                </Modal>

                <Modal
                    title = 'Help'
                    width = '70%'
                    centered
                    visible = { this.state.help_visible }
                    footer = { null }
                    onCancel = { () => this.displayHelp( false ) }
                >
                    <p>This graphing tool provides a visualization aid for time series data.  <a href="https://www.unavco.org/data/web-services/documentation/documentation.html#!/gps/getPositionByStationId">UNAVCO's Web Services</a> provides the data via the CWU analysis center.</p>
                    <h3>Getting Started</h3>
                    <p>To get started, please type a station's 4-character id into the search box - add an individual station or multiple stations</p>
                    <p>Remove individual stations by clicking the close icon next to its name, or clear all results by clicking the close icon on the search bar.</p>
                    <h3>View Mode</h3>
                    <p>There are currently two view modes - the consolidate view will show all the time series on one graph and the individual view will display each station's time series separately.</p>
                    <h3>Settings</h3>
                    <p>By clicking on the gear icon, you can update the reference frame, select the data post processing, show/hide errorbars, and show/hide major events.</p>
                    <h3>Contact Us</h3>
                    <p>Email <a href="mailto:instrumentation@unavco.org">instrumentation@unavco.org</a> if you have any questions regarding the usage of this application.</p>
                </Modal>
            </div>
        );
    }
}

App.defaultProps = {
    default_reference_frame : 'NAM08',
    default_view : 'multi',
    default_processing : 'uncleaned'
};

export default withRouter( App );


// WEBPACK FOOTER //
// ./src/components/App/App.js